export const breakpointMinWidth = {
  bp2: 576,
  bp3: 768,
  bp4: 992,
  bp5: 1200,
} as const;

export const breakpointMaxWidth = {
  bp2: breakpointMinWidth['bp2'] - 1,
  bp3: breakpointMinWidth['bp3'] - 1,
  bp4: breakpointMinWidth['bp4'] - 1,
  bp5: breakpointMinWidth['bp5'] - 1,
} as const;

/**
 * # Breakpoints
 *
 * These values have been adjusted to take a mobile-first approach.
 * A couple of breakpoints were added to target specific viewports
 * (e.g. tablet-only).
 *
 * ## Usage
 *
 * ```jsx
 * import { tokens } from '@packages/systems/spring';
 * import { emotionStyled } from '@packages/utilities/styled';
 *
 * const ResponsiveComponent = styled('div')({
 *   padding: 20,
 *   [tokens.breakpoints.bp2]: {
 *     padding: 40,
 *   },
 *   [tokens.breakpoints.bp3]: {
 *     padding: 60,
 *   },
 * });
 * ```
 */
export const breakpoints = {
  /**
   * Smallest breakpoint. Only appears for smaller screen devices.
   */
  bp1Only: `@media (max-width: ${breakpointMaxWidth.bp2}px)`,
  /**
   * Tablet-sized devices and larger. (576px)
   */
  bp2: `@media (min-width: ${breakpointMinWidth.bp2}px)`,
  /**
   * Tablet-sized+ devices and larger. (768px)
   */
  bp3: `@media (min-width: ${breakpointMinWidth.bp3}px)`,
  /**
   * Desktop-sized devices and larger. (992px)
   */
  bp4: `@media (min-width: ${breakpointMinWidth.bp4}px)`,
  /**
   * Desktop-sized devices with larger screen. (1200px)
   */
  bp5: `@media (min-width: ${breakpointMinWidth.bp5}px)`,
} as const;
